import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initTelegramWebApp } from '@/lib/telegram';
import { initTheme } from '@/lib/theme';
import { initI18n } from '@/lib/i18n';
import './index.css';

// Telegram ichida ochilganda WebApp.ready()/expand() imkon qadar tez chaqirilishi kerak
// (Telegram'ning o'z yuklanish indikatorini yashirish uchun) — render'dan oldin.
initTelegramWebApp();

// Tema va til — render'dan OLDIN, aks holda birinchi kadrda noto'g'ri
// rang/til chaqnab ketadi (index.html'dagi anti-flash skripti bilan birga ishlaydi).
initTheme();
initI18n();

// MOCK YO'Q. Ilova doim haqiqiy backend bilan ishlaydi (`VITE_API_BASE_URL`).
// MSW (`src/mocks/`) faqat vitest testlari uchun qoldirildi — brauzer bundle'iga
// umuman kirmaydi. Sabab: mock'da bor, backend'da yo'q endpoint jimgina
// "ishlayotgandek" ko'rinib, real serverda 404 berardi (BUGS.md BUG-010).
const splash = document.getElementById('splash');
splash?.remove();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
